import { render, staticRenderFns } from "./Oznam.vue?vue&type=template&id=464c9769&"
import script from "./Oznam.vue?vue&type=script&lang=js&"
export * from "./Oznam.vue?vue&type=script&lang=js&"
import style0 from "./Oznam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports